// @flow
import * as R from "ramda"

import { get } from "./get"

// $FlowFixMe: error revealed by updating Flow and Ramda libdef, please fix
const mapValues = R.curry(
  // eslint-disable-next-line flowtype/no-weak-types
  (iteratee: string | ((any, ?string, ?Object) => any), obj: Object): Object =>
    R.mapObjIndexed(typeof iteratee === "string" ? get(iteratee) : iteratee, obj),
)

export default mapValues
